"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=algoliaError.js.map